<div class="nivel-logro-cell">
    <mat-form-field *ngIf="criterio.niveles.length > 1 && view === 'tabla'" appearance="standard" class="level-select">
        <!-- <mat-label>Nivel</mat-label> -->
        <mat-select (selectionChange)="criterioGroup.limpiarFormYGuardar()" [formControl]="nivelForm">
            <mat-option *ngFor="let nivel of criterio.niveles" [value]="nivel.id">
                {{nivel.nickName}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <ng-container *ngFor="let nivel of criterio.niveles">
        <ng-container *ngIf="nivel.id === nivelForm.value">
            <app-boton-criterio-group #criterioGroup [view]="view" [alumno]="alumno" [nivel]="nivel" [fecha$]="fecha$"
                [eventoUnidadID]="eventoUnidadID" [alumnos$]="alumnos$" [mostrarAutoevaluacion$]="mostrarAutoevaluacion$"></app-boton-criterio-group>
        </ng-container>
    </ng-container>
</div>
